export default __webpack_public_path__ + "media/images/react_icons/casatb/logo-sm-bg-dark-19c665086d3b9360b8c342120cb2824e.svg";